import './muteluloading.css'

export default function MuteluLoading() {
  return (
    <div className="mutelu-loading-wrap" role="status" aria-live="polite">
      <div className="mutelu-orbit" aria-hidden="true">
        <span className="mutelu-ring ring-1" />
        <span className="mutelu-ring ring-2" />
        <span className="mutelu-ring ring-3" />
        <span className="mutelu-dot dot-1" />
        <span className="mutelu-dot dot-2" />
        <span className="mutelu-dot dot-3" />
        <span className="mutelu-ring ring-4" />
        <span className="mutelu-dot dot-4" />
      </div>
    </div>
  )
}
